import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import useCepTemplateSelectorListConfig from './CepTemplateSelectorList.config';
import { mayaCepDuplicateRoute } from 'basics/constants/routes.constants';
import GridList from 'components/GridList/GridList';
import { CustomerEngagementPlanning } from 'generated/maya.types';
import Box from 'yoda-ui/components/Box';

type CepTemplateSelectorListPropsType = {
  ceps: CustomerEngagementPlanning[];
  loading: boolean;
  count: number;
  onPageChange: (newPage: number) => void;
  onPageSizeChange: (newPageSize: number) => void;
};

const CepTemplateSelectorList: FC<CepTemplateSelectorListPropsType> = ({
  ceps,
  loading,
  count,
  onPageChange,
  onPageSizeChange,
}) => {
  const navigate = useNavigate();

  const cepFromTemplateCallback = async (cepId: string) => {
    navigate(`${mayaCepDuplicateRoute}?cepSourceId=${cepId}`);
  };

  const {
    cepTemplateListColumnConfig,
  } = useCepTemplateSelectorListConfig({ cepFromTemplateCallback });

  return (
    <Box >
      <GridList
        loading={ loading }
        getRowId={ (row) => row._id }
        columnConfig={ cepTemplateListColumnConfig }
        rows={ ceps }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        rowCountState={ count }
        disableColumnMenu={ true }
      />
    </Box>
  );
};

export default CepTemplateSelectorList;
